import { Dropdown } from 'react-bootstrap';
import { useContext } from 'react';
import { ApiTokenContext } from 'shiplab-components/ApiTokenManagementPanel';
import { ApiToken } from 'models/ApiToken';

type ApiTokenTableActionDropdownProps = {
  apiToken: ApiToken;
};

const ApiTokenTableActionDropdownItems: React.FC<ApiTokenTableActionDropdownProps> = ({
  apiToken,
}) => {
  const context = useContext(ApiTokenContext);

  if (!context) {
    return null;
  }

  const { handleEdit, handleDelete } = context;

  return (
    <>
      <Dropdown.Item
        eventKey="edit"
        onClick={() => handleEdit(apiToken)}
        disabled={apiToken.is_expired}
      >
        Update description
      </Dropdown.Item>
      <Dropdown.Item
        eventKey="delete"
        className="text-danger"
        onClick={() => handleDelete(apiToken)}
      >
        Delete
      </Dropdown.Item>
    </>
  );
};

export default ApiTokenTableActionDropdownItems;
